import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import ServiceMarquee from "@/components/site/ServiceMarquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Gallery from "@/components/site/Gallery";
import Coverage from "@/components/site/Coverage";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsappFloat from "@/components/site/WhatsappFloat";

const Home = () => (
  <SmoothScroll>
    <div className="App grain bg-ink" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <ServiceMarquee />
        <Manifesto />
        <Services />
        <Process />
        <Gallery />
        <Coverage />
        <Contact />
      </main>
      <Footer />
      <WhatsappFloat />
    </div>
  </SmoothScroll>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
